import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './i18n'
import Home from './pages/Home'
import Services from './pages/Services'
import Contact from './pages/Contact'
import Footer from './components/Footer'
import Navbar from './components/Navbar'
import About from './pages/About'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Trends from './pages/Trends'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from './styles/GlobalStyles'
import ThankYou from './pages/ThankYou'

const theme = {
  colors: {
    primary: '#d5728a',
    secondary: '#9a4c66',
    background: '#fcf8f9',
    text: '#1b0d12',
    border: '#e7cfd7'
  },
  fonts: {
    primary: '"Plus Jakarta Sans", "Noto Sans", sans-serif',
    heading: '"Playfair Display", serif'
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px'
  }
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <BrowserRouter>
        <div
          className='relative flex size-full min-h-screen flex-col bg-[#fcf8f9] group/design-root overflow-x-hidden'
          style={{ fontFamily: theme.fonts.primary }}
        >
          <div className='layout-container flex h-full grow flex-col'>
            <Navbar />
            <main className='flex-grow'>
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/about' element={<About />} />
                <Route path='/services' element={<Services />} />
                <Route path='/trends' element={<Trends />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/privacy' element={<Privacy />} />
                <Route path='/terms' element={<Terms />} />
                <Route path='/thank-you' element={<ThankYou />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
